<template>
  <section>
    <div v-if="isEndorsement">
      <div class="table">
        <template v-if="form.cust_typ == 1">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div
            v-for="(item,index) in compareData.list"
            :key="index"
          >
            <div
              v-if="!item.isHasClassId||(classId != 14&&item.isHasClassId)"
              class="tr">
              <span>{{ item.name }}</span>
              <span
                v-if="form[item.field] === oldForm[item.field]"
                v-copy="showCompare(item, form[item.field])">
                {{ showCompare(item, form[item.field]) }}
              </span>
              <span
                v-else
                class="compare">
                <span class="text-line color-danger">
                  {{ showCompare(item, oldForm[item.field]) }}
                </span>
                <span class="color-success">
                  {{ showCompare(item, form[item.field]) }}
                </span>
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            v-for="(item,index1) in compareData.list1"
            :key="index1"
            class="tr">
            <span>{{ item.name }}</span>
            <span
              v-if="form[item.field] === oldForm[item.field]"
              v-copy="showCompare(item, form[item.field])">
              {{ showCompare(item, form[item.field]) }}
            </span>
            <span
              v-else
              class="compare">
              <span class="text-line color-danger">
                {{ showCompare(item, oldForm[item.field]) }}
              </span>
              <span class="color-success">
                {{ showCompare(item, form[item.field]) }}
              </span>
            </span>
          </div>
        </template>
        <div
          v-for="(item,index2) in compareData.list3"
          :key="'index2'+index2"
          class="tr">
          <span>{{ item.name }}</span>
          <span
            v-if="form[item.field] === oldForm[item.field]"
            v-copy="showCompare(item, form[item.field])">
            {{ showCompare(item, form[item.field]) }}
          </span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">
              {{ showCompare(item, oldForm[item.field]) }}
            </span>
            <span class="color-success">
              {{ showCompare(item, form[item.field]) }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="table">
        <template v-if="form.cust_typ == 1">
          <div class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Title</span>
            <span :class="{'green-tip':handleCompare('isrd_title')}">
              <!-- {{ getOptionName('titleOptions', form.isrd_title) }} -->
              <alt-copy
                key_value="isrd_title"
                :text="getOptionName('titleOptions', form.isrd_title)"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Last Name</span>
            <span :class="{'green-tip':handleCompare('isrd_lst_nm')}">
              <!-- {{ form.isrd_lst_nm }} -->
              <alt-copy
                key_value="isrd_lst_nm"
                :text="form.isrd_lst_nm"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>First Name</span>
            <span  :class="{'green-tip':handleCompare('isrd_fst_nm')}">
              <!-- {{ form.isrd_fst_nm }} -->
              <alt-copy
                key_value="isrd_fst_nm"
                :text="form.isrd_fst_nm"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Date of Birth</span>
            <span :class="{'green-tip':handleCompare('isrd_dob_date')}">
              <!-- {{ form.isrd_dob_date }} -->
              <alt-copy
                key_value="isrd_dob_date"
                :text="form.isrd_dob_date"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>HKID Card No. / Passport No.</span>
            <span
              v-copy="getOptionName('idTypeOptions', form.id_type)"
              :class="{'green-tip':handleCompare('id_type')}">
              <!-- {{ getOptionName('idTypeOptions', form.id_type) }} -->
              <alt-copy
                key_value="id_type"
                :text="getOptionName('idTypeOptions', form.id_type)"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>ID Number</span>
            <span :class="{'green-tip':handleCompare('id_no')}">
              <!-- {{ form.id_no }} -->
              <alt-copy
                key_value="id_no"
                :text="form.id_no"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Mobile Number</span>
            <span  :class="{'green-tip':handleCompare('mobile_no')}">
              <!-- {{ form.mobile_no }} -->
              <alt-copy
                key_value="mobile_no"
                :text="form.mobile_no"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span  :class="{'green-tip':handleCompare('email')}">
              <!-- {{ form.email }} -->
              <alt-copy
                key_value="email"
                :text="form.email"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
              <email-tooltip :email="form.email"></email-tooltip>
            </span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span  :class="{'green-tip':handleCompare('occ')}">
              <!-- {{ getLocalAllOptionName('occupation', form.occ_id) }} -->
              <alt-copy
                key_value="occ"
                :text="form.occ"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Policyholder is one of the Named Driver?</span>
            <span  :class="{'green-tip':handleCompare('hldr_is_drvr_ind')}">
              <!-- {{ getOptionName('yesNoOptions', form.hldr_is_drvr_ind) }} -->
              <alt-copy
                key_value="hldr_is_drvr_ind"
                :text="getOptionName('yesNoOptions', form.hldr_is_drvr_ind)"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
        </template>
        <template v-else>
          <div class="tr">
            <span>Company Name</span>
            <span  :class="{'green-tip':handleCompare('isrd_com_nm')}">
              <!-- {{ form.isrd_com_nm }} -->
              <alt-copy
                key_value="isrd_com_nm"
                :text="form.isrd_com_nm"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Business Registration Number</span>
            <span  :class="{'green-tip':handleCompare('id_no')}">
              <!-- {{ form.id_no }} -->
              <alt-copy
                key_value="id_no"
                :text="form.id_no"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Company Phone No.</span>
            <span  :class="{'green-tip':handleCompare('phone_no')}">
              <!-- {{ form.phone_no }} -->
              <alt-copy
                key_value="phone_no"
                :text="form.phone_no"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Company Email</span>
            <span  :class="{'green-tip':handleCompare('email')}">
              <!-- {{ form.email }} -->
              <alt-copy
                key_value="email"
                :text="form.email"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
              <email-tooltip :email="form.email"></email-tooltip>
            </span>
          </div>
          <div class="tr">
            <span>Nature of Business</span>
            <span  :class="{'green-tip':handleCompare('bsns_nature_id')}">
              <!-- {{ getLocalAllOptionName('industry', form.bsns_nature_id) }} -->
              <alt-copy
                key_value="bsns_nature_id"
                :text="getLocalAllOptionName('industry', form.bsns_nature_id)"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <div class="tr">
            <span>Contact Person Name</span>
            <span  :class="{'green-tip':handleCompare('contact_nm')}">
              <!-- {{ form.contact_nm }} -->
              <alt-copy
                key_value="contact_nm"
                :text="form.contact_nm"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>Occupation & Position</span>-->
          <!--            <span>{{ getLocalAllOptionName('occupation', form.contact_occ_id) }}</span>-->
          <!--          </div>-->
          <div class="tr">
            <span>Contact Person Mobile No.</span>
            <span  :class="{'green-tip':handleCompare('contact_phone')}">
              <!-- {{ form.contact_phone }} -->
              <alt-copy
                key_value="contact_phone"
                :text="form.contact_phone"
                :copyKey="copyKey"
                className="key-alt-down"
                @sendKey="getKey"></alt-copy>
            </span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>Email</span>-->
          <!--            <span>{{ form.contact_email }}</span>-->
          <!--          </div>-->
        </template>
        <div class="tr">
          <span>Room</span>
          <span  :class="{'green-tip':handleCompare('addr_room')}">
            <!-- {{ form.addr_room }} -->
            <alt-copy
              key_value="addr_room"
              :text="form.addr_room"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span :class="{'green-tip':handleCompare('addr_floor')}">
            <!-- {{ form.addr_floor }} -->
            <alt-copy
              key_value="addr_floor"
              :text="form.addr_floor"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span  :class="{'green-tip':handleCompare('addr_block')}">
            <!-- {{ form.addr_block }} -->
            <alt-copy
              key_value="addr_block"
              :text="form.addr_block"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span  :class="{'green-tip':handleCompare('addr_building')}">
            <!-- {{ form.addr_building }} -->
            <alt-copy
              key_value="addr_building"
              :text="form.addr_building"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span  :class="{'green-tip':handleCompare('addr_street')}">
            <!-- {{ form.addr_street }} -->
            <alt-copy
              key_value="addr_street"
              :text="form.addr_street"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
        <div class="tr">
          <span>District</span>
          <span  :class="{'green-tip':handleCompare('addr_district')}">
            <!-- {{ getAreaName('district', form.addr_district) }} -->
            <alt-copy
              key_value="addr_district"
              :text="getAreaName('district', form.addr_district)"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span  :class="{'green-tip':handleCompare('addr_area')}">
            <!-- {{ getAreaName('area', form.addr_area) }} -->
            <alt-copy
              key_value="addr_area"
              :text="getAreaName('area', form.addr_area)"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span  :class="{'green-tip':handleCompare('addr_region')}">
            <!-- {{ getAreaName('region', form.addr_region) }} -->
            <alt-copy
              key_value="addr_region"
              :text="getAreaName('region', form.addr_region)"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </div>
      </div>
    </div>
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import OMath from '@/utils/math'

export default {
  name: 'motorPolicyHolderInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    compareList: {
      type: Array,
      default: () => ([])
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      compareData:
        {
          list:
            [
              {
                name: 'Title',
                field: 'isrd_title',
                fieldCode: 'titleOptions',
                option: 1
              },
              {
                name: 'Last Name',
                field: 'isrd_lst_nm',
              },
              {
                name: 'First Name',
                field: 'isrd_fst_nm',
              },
              {
                name: 'Date of Birth',
                field: 'isrd_dob_date',
              },
              {
                name: 'HKID Card No. / Passport No.',
                field: 'id_no',

              },
              // {
              //   name: 'ID Number',
              //   field: 'id_no',
              //
              // },
              {
                name: 'Email',
                field: 'email',
              },
              {
                name: 'Occupation',
                field: 'occ',
                // option: 0,
                // fieldCode: 'occupation'
              },
              {
                name: 'Policyholder is one of the Named Driver?',
                field: 'hldr_is_drvr_ind',
                option: 1,
                isHasClassId: true,
                fieldCode: 'yesNoOptions'
              },
            ],
          list1: [
            {
              name: 'Company Name',
              field: 'isrd_com_nm',
            },
            {
              name: 'BR Number',
              field: 'id_no',
            },
            {
              name: 'Company Phone No.',
              field: 'phone_no',
            },
            {
              name: 'Company Email',
              field: 'email',
            },
            {
              name: 'Nature of Business',
              field: 'bsns_nature_id',
              option: 0,
              fieldCode: 'industry'

            },
            {
              name: 'Name',
              field: 'contact_nm',

            },
            // {
            //   name: 'Occupation & Position',
            //   field: 'contact_occ_id',
            //   option: 0,
            //   fieldCode: 'occupation'
            // },
            {
              name: 'Phone No.',
              field: 'contact_phone',
            },
            {
              name: 'Email',
              field: 'contact_email',
            },
          ],
          list3:
            [
              {
                name: 'Room',
                field: 'addr_room',
              },
              {
                name: 'Floor',
                field: 'addr_floor',
              },
              {
                name: 'Block',
                field: 'addr_block',
              },
              {
                name: 'Building / Estate',
                field: 'addr_building',
              },
              {
                name: 'Street',
                field: 'addr_street',

              },
              {
                name: 'District',
                field: 'addr_district',
                addressCode: 'district',
                isAddress: true

              },
              {
                name: 'Area',
                field: 'addr_area',
                addressCode: 'area',
                isAddress: true
              },
              {
                name: 'Country / Region',
                field: 'addr_region',
                addressCode: 'region',
                isAddress: true
              },
            ],
        },
      copyKey: ''
    }
  },
  computed: {
    ...mapState('quote', ['carModelOptions']),
    classId() {
      return this.form.class_id || 14
    },
    localAllOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    businessPurposes() {
      return this.localAllOptions.business_purposes.filter(item => {
        return this.form.business_purposes.includes(item.id)
      })
    },
  },
  watch: {
    'form.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (val && this.classId == 11) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    }
  },
  methods: {
    ...mapActions('quote', ['updateCarModelOptions']),
    handleCompare(filed){
      let {type} = this.form
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    getLocalAllOptionName(target, value) {
      if (this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    showCompare(item, field, sunF) {
      var change = field
      if (item.option) {
        switch (item.option) {
          case 0:
            change = this.getLocalAllOptionName(item.fieldCode, field)
            break
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 24:
            change = this.getAllOptionName24(item.fieldCode, field)
            break
          case 26:
            change = this.getAllOptionName26(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      if (item.isSum) {
        change = OMath.formatMoney(field, 2, true) + 'HK$'
      }
      return change
    },
    getKey(key){
      this.copyKey = key
    },
  }
}
</script>
<style lang="scss" scoped>


.table {
  .tr {
    .compare {
      display: flex;
      align-items: center;

      & > span {
        flex: 1;
      }
    }
  }
}

</style>
